var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Box from '../box/Box';
import Icon from './Icon';
import { FaCheck } from 'react-icons/fa';
var CheckCircleIcon = function (_a) {
    var checked = _a.checked, _b = _a.color, color = _b === void 0 ? 'sunwashGold' : _b, rest = __rest(_a, ["checked", "color"]);
    return (React.createElement(Box, __assign({ border: "2px solid", borderColor: checked ? color : 'grays.4', borderRadius: "50%", width: "20px", height: "20px", pl: "3px" }, rest), checked && React.createElement(Icon, { icon: FaCheck, color: checked ? color : 'grays.4', size: 11, verticalAlign: "baseline" })));
};
CheckCircleIcon.defaultProps = {
    checked: false,
};
export default CheckCircleIcon;
//# sourceMappingURL=CheckCircleIcon.js.map